var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloudArrows = function SvgCloudArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M80.288 81.349h13.909c2.888 0 5.745-.596 8.388-1.751a20.8 20.8 0 0 0 6.965-4.957 20.6 20.6 0 0 0 4.357-7.32 20.47 20.47 0 0 0-1.5-16.57 20.7 20.7 0 0 0-5.602-6.435 20.9 20.9 0 0 0-7.743-3.648 21 21 0 0 0-8.57-.242 29.26 29.26 0 0 0-11.45-13.059 29.63 29.63 0 0 0-16.897-4.334 29.6 29.6 0 0 0-16.4 5.916 29.2 29.2 0 0 0-10.14 14.085 10.83 10.83 0 0 0-6.934 1.302 10.7 10.7 0 0 0-4.626 5.284 16.3 16.3 0 0 0-6.653.172 16.2 16.2 0 0 0-6.016 2.821 16 16 0 0 0-4.355 4.989 15.87 15.87 0 0 0-1.175 12.86 16 16 0 0 0 3.38 5.684 16.1 16.1 0 0 0 5.406 3.847 16.25 16.25 0 0 0 6.512 1.356h22.812",
    className: "cloud-arrows_svg__orange-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m53.313 92.133 4.195 5.81M61.704 92.133l-4.196 5.81V63.129M73.141 53.995l-4.196-5.81M64.75 53.995l4.196-5.81v34.813",
    className: "cloud-arrows_svg__white-stroke"
  })));
};
export default SvgCloudArrows;